export const addressToString = address => {
	const addressString = [
		address?.street || '',
		address?.city || '',
		address?.region || '',
		address?.postcode || '',
	]
		.filter(x => x !== '')
		.join(', ');
	return addressString;
};
